import { InputParsedNumber, Text } from '@shared/components'
import { DEFAULT_CURRENCY } from '@shared/constants'
import { useSessionContext } from '@shared/hooks'
import { Col, Flex, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  isEditable?: boolean
  orderPrice?: number
}

export const CreditFields = ({ orderPrice }: Props) => {
  const { t } = useTranslation()
  const { broker } = useSessionContext()

  if (broker) return

  return (
    <Flex vertical gap={12}>
      <Flex
        align="center"
        gap={12}
        justify="space-between"
        style={{ paddingBottom: 12 }}
      >
        <Text size={16} strong>
          {t('credit')}
        </Text>
      </Flex>

      <Row gutter={12}>
        <Col span={24}>
          <Form.Item name="credit" label={t('amount_used_from_balance')}>
            <InputParsedNumber
              placeholder={t('amount_used_from_balance')}
              min={0}
              max={orderPrice}
              precision={2}
              suffix={DEFAULT_CURRENCY}
              className="w-full"
            />
          </Form.Item>
        </Col>
      </Row>
    </Flex>
  )
}
